import { render, staticRenderFns } from "./OfmUser.vue?vue&type=template&id=370d9bf1&"
import script from "./OfmUser.vue?vue&type=script&lang=js&"
export * from "./OfmUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports